let responderResolution = [
  'SECONDS',
  'TENTHS_OF_SECONDS',
  'MILLIS',
  'MICROS'
]

export default responderResolution
